// removed by extract-text-webpack-plugin
module.exports = {"list":"_3KvBw28","link":"_2eEnuyj","link_isJobs":"_1nxN61I","link_isLearning":"_3DTczJS","link_isBusiness":"_3pzi3w4","link_isVolunteering":"uYzC-t6"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/PartnerSites/PartnerSites.less
 ** module id = 718
 ** module chunks = 0
 **/